import SubscriptionCardBack from './Subscription/Back';
import SubscriptionCardFront from './Subscription/Front';

export const cardDictionary = {
  subscription: {
    back: SubscriptionCardBack,
    front: SubscriptionCardFront,
  },
};
